var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(!_vm.loading && _vm.recipe)?[_c('recipe-content',{attrs:{"recipe":_vm.recipe}})]:_vm._e(),(_vm.loading)?[(_vm.loading)?_c('loading-spin',{attrs:{"height":300}}):_vm._e()]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }